module.exports = __webpack_public_path__ + "static/media/arrow-down.6198c1b0.svg";